import { useState, useEffect, useCallback } from 'react';
import { api } from '../lib/api';

interface User {
  id: string;
  email: string;
  name: string;
  status: string;
  auth_provider: string;
}

interface AuthState {
  user: User | null;
  tenantSlug: string;
  role: string;
  loading: boolean;
  error: string | null;
}

export function useAuth() {
  const [state, setState] = useState<AuthState>({
    user: null,
    tenantSlug: '',
    role: '',
    loading: true,
    error: null,
  });

  const checkAuth = useCallback(async () => {
    try {
      const data = await api.get<{
        user: User;
        tenant: { id: string; slug: string };
        role: string;
      }>('/auth/me');

      setState({
        user: data.user,
        tenantSlug: data.tenant.slug,
        role: data.role,
        loading: false,
        error: null,
      });
    } catch {
      setState(prev => ({ ...prev, user: null, loading: false }));
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = useCallback(async (jti: string, tenantSlug: string) => {
    setState(prev => ({ ...prev, loading: true, error: null }));
    try {
      await api.post('/auth/login', { jti, tenant_slug: tenantSlug });
      await checkAuth();
    } catch (err: any) {
      setState(prev => ({ ...prev, loading: false, error: err.message }));
    }
  }, [checkAuth]);

  return { ...state, login, checkAuth };
}
